import styled from "styled-components";

import { AVATAR_MODAL_CROP_PX } from "./const";

// TODO(orcs-migration): Remove once Avatar modal can use ORCS `headerAvatar` + `customSize` for this size; see PreviewMode.
/** Click target wrapping modal preview (local substitute for header avatar frame). */
export const AvatarModalPreviewTrigger = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  /* No border-radius here — Preview draws the circle; a 50% clip on the button was mismatching when Preview was ~412px (400 + borders). */
  width: ${({ $width }) => $width};
  height: ${({ $width }) => $width};
  box-sizing: border-box;
`;

export const StyledImageEditorContainer = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  position: relative;
  width: ${AVATAR_MODAL_CROP_PX}px;
  height: ${AVATAR_MODAL_CROP_PX}px;
  border-radius: 6px;
`;

export const ZoomControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const ZoomControlButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e8f4fd;
    border-color: #007bc7;
    color: #333;
  }

  &:active {
    background-color: #d1e9fb;
    border-color: #007bc7;
    color: #333;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
